import React, { useRef, useEffect, useState } from 'react';
import styles from './ProblemSection.module.scss';
import { motion } from 'framer-motion';

const problems = [
  { icon: 'bank', title: 'Home Loan Deposits', desc: 'Huge deposits required to enter market' },
  { icon: 'time', title: 'Saving Time', desc: 'It takes 5-10 years to save a deposit' },
  { icon: 'home', title: 'House Prices', desc: 'House prices are unattainable for most' },
  { icon: 'digital', title: 'Digital Platform', desc: 'No centralised real estate investing platform' },
];

const ProblemSection = () => {
  const ref = useRef();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (!ref.current) return;
      const rect = ref.current.getBoundingClientRect();
      if (rect.top < window.innerHeight - 100) setVisible(true);
    };
    window.addEventListener('scroll', onScroll);
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
        delayChildren: 0.3
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.9, ease: "easeOut" }
    }
  };

  const iconVariants = {
    hidden: { scale: 0.5, opacity: 0 },
    visible: {
      scale: 1,
      opacity: 1,
      transition: { duration: 1.0, ease: "easeOut", delay: 0.3 }
    }
  };

  return (
    <section ref={ref} className={styles.problemSection}>
      <motion.h2
        className={styles.title}
        initial={{ opacity: 0, y: -15 }}
        animate={visible ? { opacity: 1, y: 0 } : { opacity: 0, y: -15 }}
        transition={{ duration: 0.8 }}
      >
        Problem
      </motion.h2>
      <motion.div
        className={styles.grid}
        initial="hidden"
        animate={visible ? "visible" : "hidden"}
        variants={containerVariants}
      >
        {problems.map((item, idx) => (
          <motion.div 
            className={styles.card} 
            key={idx}
            variants={itemVariants}
          >
            <motion.div 
              className={`${styles.icon} ${styles[item.icon]}`}
              variants={iconVariants}
            ></motion.div>
            <h3>{item.title}</h3>
            <p>{item.desc}</p>
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
};

export default ProblemSection;
